import { render, staticRenderFns } from "./cooperationDetail.vue?vue&type=template&id=2c2cd4ed&scoped=true"
import script from "./cooperationDetail.vue?vue&type=script&lang=js"
export * from "./cooperationDetail.vue?vue&type=script&lang=js"
import style0 from "./cooperationDetail.vue?vue&type=style&index=0&id=2c2cd4ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2cd4ed",
  null
  
)

export default component.exports